import React from "react";
import { methodSteps } from "../../data/home";
export function Method() {
  return <section id="methode" className="scroll-mt-24 px-5 py-20 md:px-8 md:py-32" data-id="element-137" data-mp="1rtwsew4uoxo3">
      <div className="mx-auto max-w-7xl" data-id="element-138" data-mp="1rw15o4on3911">
        <div className="mx-auto max-w-3xl text-center" data-id="element-139" data-mp="1vuqhvtxxykj3">
          <p className="text-[15px] font-medium text-muted" data-id="element-140" data-mp="20uv0bpietpby">Notre méthode</p>
          <h2 className="mt-3 text-4xl font-semibold leading-[1.05] tracking-tightest md:text-6xl" data-id="element-141" data-mp="20w61dhkh0izd">
            Trois étapes pour faire travailler votre épargne.
          </h2>
        </div>

        <ol className="relative mt-16 grid gap-12 md:mt-20 md:grid-cols-3 md:gap-10" data-id="element-142" data-mp="2ar7t8l64rz5n">
          <span className="absolute left-0 right-0 top-6 hidden h-px bg-line md:block" aria-hidden="true" data-id="element-143" data-mp="2fl2c5mdwwa3o" />
          {methodSteps.map((step, i) => <li key={step.title} className="relative" data-id="element-144" data-mp="2oli9sf7z4n0m" data-mpi={i}>
              <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-ink text-[15px] font-semibold text-canvas ring-8 ring-canvas" data-id="element-145" data-mp="2tjjt919baocm">
                {i + 1}
              </span>
              <h3 className="mt-7 text-2xl font-semibold tracking-tight" data-id="element-146" data-mp="36n5wby09xuv0">{step.title}</h3>
              <p className="mt-3 text-[17px] leading-relaxed text-muted" data-id="element-147" data-mp="32laxr19q9vkx">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}